// prettier-ignore
export const ESportDataActionTypes = {
  SET_E_SPORT_LIST_DATA: 'SET_E_SPORT_LIST_DATA',
  SET_CASHED_E_SPORT_PREMATCH_GAMES: 'SET_CASHED_E_SPORT_PREMATCH_GAMES',
  SET_ESPORT_GAMES: 'SET_ESPORT_GAMES',
  SET_ESPORT_GAME_DATA: 'SET_ESPORT_GAME_DATA',
  SET_ESPORT_ADDITIONAL_DATA: 'SET_ESPORT_ADDITIONAL_DATA'
};
